import { useState } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { PrivacyTip, ReceiptLong } from '@mui/icons-material'

import { ReportHeader } from '@/modules/reports/common'
import type { Period } from '@/utils/dates'

import { PrivacyEvidenceTab } from './PrivacyEvidenceTab'
import { ReconciliationTab } from './ReconciliationTab'

/** The proof pack: revenue reconciliation and opt-out evidence, for one period. */
export function ProofPage() {
    const [period, setPeriod] = useState<Period>('30d')
    const [tab, setTab] = useState(0)
    return (
        <Box sx={{ p: 3 }}>
            <ReportHeader
                title="Proof"
                subtitle="Evidence you can hand to finance and to a regulator."
                period={period}
                onPeriodChange={setPeriod}
            />
            <Tabs
                value={tab}
                onChange={(_, v: number) => setTab(v)}
                sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
            >
                <Tab icon={<ReceiptLong />} iconPosition="start" label="Revenue reconciliation" />
                <Tab icon={<PrivacyTip />} iconPosition="start" label="Opt-out evidence" />
            </Tabs>
            {tab === 0 ? (
                <ReconciliationTab period={period} />
            ) : (
                <PrivacyEvidenceTab period={period} />
            )}
        </Box>
    )
}
